import { useEffect, useState } from 'react';
import { useSaveQueueStore } from '@/state/saveQueue';
import type { SaveStatus } from '@/types';

const SAVING_DEBOUNCE_MS = 200;

/**
 * Reads the live save status from saveQueue. Suppresses the Saving state when a
 * mutation completes in <200ms (the common case for a successful PATCH) so the
 * indicator doesn't flicker. Per DESIGN_SYSTEM §8.0a.
 */
export function useSaveStatus(): SaveStatus {
  const raw = useSaveQueueStore((s) => s.status);
  const [debounced, setDebounced] = useState<SaveStatus>(raw);

  useEffect(() => {
    if (raw.kind === 'saving') {
      const handle = setTimeout(() => setDebounced(raw), SAVING_DEBOUNCE_MS);
      return () => clearTimeout(handle);
    }
    setDebounced(raw);
    return undefined;
  }, [raw]);

  return debounced;
}
